import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "add-profile-pic-container" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "You look great!", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "title"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Upload a Picture", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "description"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Here's what you uploaded", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "description"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Upload a picture so people know its you!", -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "profile-pic" }
const _hoisted_15 = {
  key: 0,
  class: "progress-container"
}
const _hoisted_16 = { class: "progress-value" }
const _hoisted_17 = {
  key: 1,
  class: "picture-container"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "temp-picture"
}
const _hoisted_20 = { class: "picture-buttons" }
const _hoisted_21 = { class: "button-container flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.pictureUploaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
    ($setup.pictureUploaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13)),
    _createElementVNode("div", _hoisted_14, [
      ($setup.uploadValue != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString($setup.uploadValue) + "%", 1 /* TEXT */)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            ($setup.pictureUploaded)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "uploaded-image",
                  src: $setup.imageURL
                }, null, 8 /* PROPS */, _hoisted_18))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.userInitials), 1 /* TEXT */))
          ])),
      _createElementVNode("div", _hoisted_20, [
        ($setup.pictureUploaded)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "borderless upload",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fileInput!.click()))
            }, "Upload a different Picture"))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("input", {
        type: "file",
        ref: "fileInput",
        accept: "image/*",
        name: "image",
        id: "file",
        style: {"display":"none"},
        onChange: $setup.uploadFile
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */),
      ($setup.pictureUploaded)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('progress')))
          }, "Finish Setup"))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "outline",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.fileInput!.click()))
          }, "Upload a Picture")),
      (!$setup.pictureUploaded)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "borderless",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.emit('progress')))
          }, "Skip This for Now"))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}